
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { uiStore, documentStore } from "@/store/store";
import {
  getEmptyContainerPositionAndSize,
  getTreeNodePositionAndSize
} from "@/lib/canvas/helpers";
import { getStackingStyle } from "@/lib/canvas/drag/element-drag";
import { findNode, ROOT_ELEMENT_ID } from "@/lib/tree/tree";

@Component({
  components: {}
})
export default class DragPlaceholder extends Vue {
  get canvasDragPlaceholderPosition() {
    return uiStore.canvasDragPlaceholderPosition;
  }

  get parentNode() {
    if (!this.canvasDragPlaceholderPosition) return false;

    const maybeNode = findNode(
      documentStore.document.tree,
      this.canvasDragPlaceholderPosition.parentId
    );
    return maybeNode ? maybeNode : false;
  }

  get stackingStyle() {
    if (!this.canvasDragPlaceholderPosition) return {};

    if (!this.parentNode) return {};

    return getStackingStyle(this.parentNode);
  }

  get dragPlaceholderPositionStyle() {
    if (
      !this.canvasDragPlaceholderPosition ||
      this.canvasDragPlaceholderPosition.onlyShowTargetOutline === true
    )
      return {};

    const parentNode = findNode(
      documentStore.document.tree,
      this.canvasDragPlaceholderPosition.parentId
    );

    if (!parentNode) return {};

    const widthOrHeightNumber = 8;
    // - 1 for the border of the parent element
    const widthOrHeightValue = `${widthOrHeightNumber}px`;

    if (parentNode.children.length === 0) {
      // this is similar to that shit in DragMixin.ts
      const elementPositionAndSize =
        parentNode.id === ROOT_ELEMENT_ID
          ? getEmptyContainerPositionAndSize()
          : getTreeNodePositionAndSize(parentNode);

      if (!elementPositionAndSize) return {};

      // eslint-disable-next-line prefer-const
      let { x, y, width, height } = elementPositionAndSize;

      if (width - 40 > 100) {
        x = x + 20;
        width = width - 40;
      }

      return {
        display: "block",
        top: `${y + height / 2 - widthOrHeightNumber / 2}px`,
        left: `${x}px`,
        width: `${width}px`,
        height: widthOrHeightValue
      };
    } else {
      const overNode =
        parentNode.children[this.canvasDragPlaceholderPosition.nodeIndex];
      // this is a little dangerous. What if the index of the placeholder is not right and the shit doesnt exist?
      // when we upgrade TypeScript to use noUncheckedIndexedAccess, this will be caught

      const elementPositionAndSize = getTreeNodePositionAndSize(overNode); // this is similar to that shit in DragMixin.ts
      const stackingStyle = getStackingStyle(parentNode);

      if (!elementPositionAndSize) return {};

      const { x, y, width, height } = elementPositionAndSize;

      if (stackingStyle === "vertical") {
        if (this.canvasDragPlaceholderPosition.position === "before") {
          return {
            display: "block",
            top: `${y - (widthOrHeightNumber / 2 - 1)}px`,
            left: `${x}px`,
            width: `${width}px`,
            height: widthOrHeightValue
          };
        } else if (this.canvasDragPlaceholderPosition.position === "after") {
          return {
            display: "block",
            top: `${height + y - (widthOrHeightNumber / 2 + 1)}px`,
            left: `${x}px`,
            width: `${width}px`,
            height: widthOrHeightValue
          };
        }
      } else if (stackingStyle === "horizontal") {
        if (this.canvasDragPlaceholderPosition.position === "before") {
          return {
            display: "block",
            top: `${y}px`,
            left: `${x - widthOrHeightNumber / 2}px`,
            height: `${height}px`,
            width: widthOrHeightValue
          };
        } else if (this.canvasDragPlaceholderPosition.position === "after") {
          return {
            display: "block",
            left: `${width + x - widthOrHeightNumber / 2}px`,
            top: `${y}px`,
            height: `${height}px`,
            width: widthOrHeightValue
          };
        }
      }
    }

    return {};
  }

  get dragTargetOutlineStyle() {
    if (!this.parentNode) return {};

    const elementPositionAndSize =
      this.parentNode.id === ROOT_ELEMENT_ID &&
      documentStore.document.tree.root.children.length === 0
        ? getEmptyContainerPositionAndSize()
        : getTreeNodePositionAndSize(this.parentNode);

    if (!elementPositionAndSize) return {};

    const { x, y, width, height } = elementPositionAndSize;

    return {
      display: "block",
      position:
        "absolute" /* this won't work if something other than the window has position relative on it
        maybe we could mount the overlaid ui chrome inside the body */,
      top: `${y}px`,
      left: `${x}px`,
      width: `${width}px`,
      height: `${height}px`
    };
  }
}
